// mds-dojo — dijit/_editor/plugins/ToggleDir — FAITHFUL port of
// references/dijit/_editor/plugins/ToggleDir.js. Toggles the edited document's text
// direction independent of the page. Registers itself into _Plugin.registry.
//
// ADAPTATIONS: import paths repathed; `dojo/_base/declare` → declare-runtime.
//   Unused imports dropped: dojo/dom-style, dojo/_base/kernel, dojo/on (the button's
//   own .on()/.watch() are used, not the dojo/on module).
import declare from '../../../dojo/_base/declare-runtime'; // declare
import lang from '../../../dojo/_base/lang'; // lang.hitch
import _Plugin from '../_Plugin';
import ToggleButton from '../../form/ToggleButton';

// module:
//		dijit/_editor/plugins/ToggleDir

var ToggleDir: any = declare("dijit._editor.plugins.ToggleDir", _Plugin, {
	// summary:
	//		This plugin is used to toggle direction of the edited document,
	//		independent of what direction the whole page is.

	// Override _Plugin.useDefaultCommand: processing is done in this plugin
	// rather than by sending commands to the Editor
	useDefaultCommand: false,

	command: "toggleDir",

	// Override _Plugin.buttonClass to use a ToggleButton for this plugin rather than a vanilla Button
	buttonClass: ToggleButton,

	_initButton: function(){
		this.inherited(arguments);

		var button = this.button,
			editorLtr = this.editor.isLeftToRight();

		this.own(this.button.on("change", lang.hitch(this, function(checked: any){
			this.editor.set("textDir", editorLtr ^ checked ? "ltr" : "rtl");
		})));

		// Button should be checked if the editor's textDir is opposite of the editor's dir.
		// Note that the arrow in the icon points in opposite directions depending on the editor's dir.
		var editorDir = editorLtr ? "ltr" : "rtl";
		function setButtonChecked(textDir: any){
			button.set("checked", textDir && textDir !== editorDir, false);
		}
		setButtonChecked(this.editor.get("textDir"));
		this.editor.watch("textDir", function(name: any, oval: any, nval: any){
			setButtonChecked(nval);
		});
	},

	updateState: function(){
		// summary:
		//		Over-ride for button state control for disabled to work.
		this.button.set("disabled", this.get("disabled"));
	}
});

// Register this plugin.
_Plugin.registry["toggleDir"] = function(){
	return new ToggleDir({command: "toggleDir"});
};

export default ToggleDir;
